/**
 * Loại thanh toán
 * NCDINH 24/11/2022
 */
export default {
  InvestmentAdvance: 1, //Tạm ứng vốn đầu tư
  AdvanceInvestment: 2, // Ứng trước vốn đầu tư
};
